//
import React from 'react';
import { Dimensions, ScrollView, StyleSheet } from 'react-native';
import { MAX_WIDTH, SIDE_PADDING } from '../../constants';
const DEVICE_WIDTH = Dimensions.get('window').width;

type Props = {};

const HorizontalScroll: React.FC<Props> = (props) => {
  return (
    <ScrollView
      horizontal={true}
      style={{ width: Math.min(DEVICE_WIDTH, MAX_WIDTH), left: -SIDE_PADDING }}
      contentContainerStyle={{
        paddingLeft: SIDE_PADDING,
        paddingRight: SIDE_PADDING,
        paddingBottom: 5
      }}
    >
      {props.children}
    </ScrollView>
  );
};

const styles = StyleSheet.create({});

export default HorizontalScroll;
